
import { reactive } from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "settings-component",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "api/Form/loadForm",
      apiSaveMethod: "api/Form/saveForm",
      form: "AppEinstellungen",
      page: "Einstellungen",
      remoteId: "",
      waitForResponse: true
      

    });

    return {
      request
    };
  }
};
